/* eslint-disable indent */
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useCoreAuth } from '@carvana/core-auth';
import { useExperiment } from '@carvana/core-experiment';
import { LoginCreateAccount } from './login-create-account';
import { SearchProvider } from '../../../components/search/context';
import { SearchField } from '../../search';
import {
  HeroWrapper,
  HeroBackground,
  HeroTitle,
  StyledSearchContainer,
  SmallSeparator
} from './hero.styles';
import { useSupportContext } from '../../../helpers/context-provider';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';
import { useBreakpoint } from '../../../helpers/breakpoint-provider';

export const Hero = () => {
  const { authName, profile, isLoading } = useSupportContext() || {};
  const { isMobile } = useBreakpoint();
  const { getUserState } = useCoreAuth();
  const { isLoggedIn } = getUserState();
  const { assignedBucket } = useExperiment('inventory-ltw-help-auth-contact-us') || {};
  const searchPlaceholder =
    assignedBucket === 'treatment' ? 'Search Support Topics' : 'Ask Anything';
  const [ref] = SendInViewEvent({
    isLoading,
    component_name: 'home_hero',
    data: profile
  });

  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "austin_vm_background.jpg" }) {
        childImageSharp {
          fluid(quality: 90, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  const imageData = data.desktop.childImageSharp.fluid;

  return (
    <HeroWrapper isUserLoggedIn={isLoggedIn} ref={ref}>
      <HeroBackground
        Tag="div"
        fluid={imageData}
        isUserLoggedIn={isLoggedIn}
        style={{
          height:
            !isLoading &&
            (isMobile ? (isLoggedIn ? '250px' : '260px') : isLoggedIn ? '260px' : '358px')
        }}
      >
        <HeroTitle>
          {isLoggedIn
            ? `HI ${profile?.name?.first || authName || 'customer'}! How can we help you?`
            : 'What do you need help with?'}
        </HeroTitle>

        <SearchProvider>
          <StyledSearchContainer>
            <SearchField
              autocomplete={true}
              updateQueryParam={false}
              placeholder={searchPlaceholder}
            />
          </StyledSearchContainer>
        </SearchProvider>

        {!isLoggedIn && (
          <div style={{ width: '100%' }}>
            <LoginCreateAccount />
            <SmallSeparator />
          </div>
        )}
      </HeroBackground>
    </HeroWrapper>
  );
};
